(() => {
  const FLAG_GROUPS = {
    'North America': ['United States','Canada','Mexico'],
    'Central America': ['Belize','Costa Rica','El Salvador','Guatemala','Honduras','Nicaragua','Panama'],
    'Caribbean': ['Antigua & Barbuda','Bahamas','Barbados','Cuba','Dominican Republic','Grenada','Haiti','Jamaica','Puerto Rico','Saint Kitts & Nevis','Saint Lucia','Saint Vincent & the Grenadines','Trinidad & Tobago'],
    'South America': ['Argentina','Bolivia','Brazil','Chile','Colombia','Ecuador','Guyana','Paraguay','Peru','Suriname','Uruguay','Venezuela'],
    'Europe': ['Albania','Austria','Belgium','Bosnia & Herzegovina','Bulgaria','Croatia','Cyprus','Czech Republic','Denmark','England','Estonia','Finland','France','Georgia','Germany','Greece','Hungary','Iceland','Ireland','Italy','Kosovo','Latvia','Lithuania','Luxembourg','Malta','Moldova','Montenegro','Netherlands','North Macedonia','Northern Ireland','Norway','Poland','Portugal','Romania','Scotland','Serbia','Slovakia','Slovenia','Spain','Sweden','Switzerland','Turkey','Ukraine','Wales'],
    'Africa': ['Algeria','Angola','Benin','Botswana','Burkina Faso','Burundi','Cameroon','Cape Verde','Central African Republic','Chad','Comoros','Congo','DR Congo','Egypt','Equatorial Guinea','Eritrea','Eswatini','Ethiopia','Gabon','Gambia','Ghana','Guinea','Guinea-Bissau','Ivory Coast','Kenya','Lesotho','Liberia','Libya','Madagascar','Malawi','Mali','Mauritania','Mauritius','Morocco','Mozambique','Namibia','Niger','Nigeria','Rwanda','Senegal','Sierra Leone','Somalia','South Africa','South Sudan','Sudan','Tanzania','Togo','Tunisia','Uganda','Zambia','Zimbabwe'],
    'Middle East': ['Bahrain','Iran','Iraq','Israel','Jordan','Kuwait','Lebanon','Oman','Palestine','Qatar','Saudi Arabia','Syria','United Arab Emirates','Yemen'],
    'Asia': ['Afghanistan','Bangladesh','Bhutan','Brunei','Cambodia','China','Hong Kong','India','Indonesia','Japan','Kazakhstan','Kyrgyzstan','Laos','Malaysia','Maldives','Mongolia','Myanmar','Nepal','North Korea','Pakistan','Philippines','Singapore','South Korea','Sri Lanka','Taiwan','Tajikistan','Thailand','Turkmenistan','Uzbekistan','Vietnam'],
    'Oceania': ['Australia','Fiji','New Zealand','Papua New Guinea','Samoa','Solomon Islands','Tonga','Vanuatu']
  };

  const addOptions = (select) => {
    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'Choose a flag';
    blank.disabled = true;
    blank.selected = true;
    select.appendChild(blank);

    Object.entries(FLAG_GROUPS).forEach(([region, countries]) => {
      const group = document.createElement('optgroup');
      group.label = region;
      countries.forEach(country => {
        const option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        group.appendChild(option);
      });
      select.appendChild(group);
    });
  };

  const makeSelect = (propertyName, formId, required = true) => {
    const select = document.createElement('select');
    select.className = 'ci-field ci-pack-flag-select';
    select.name = `properties[${propertyName}]`;
    if (formId) select.setAttribute('form', formId);
    if (required) select.required = true;
    addOptions(select);
    return select;
  };

  const upgradeSingleFlagInputs = (root) => {
    root.querySelectorAll('input[type="text"][name="properties[Flag]"]').forEach(input => {
      const select = makeSelect('Flag', input.getAttribute('form'), input.required);
      if (input.id) select.id = input.id;
      input.replaceWith(select);
    });
  };

  const upgradeTeamFlags = (root) => {
    const handle = root.dataset.handle;
    if (!['team-flags-pack','team-national-pack','complete-team-pack'].includes(handle)) return;

    const roster = root.querySelector('textarea[name="properties[11-player roster]"]');
    if (!roster) return;
    const formId = roster.getAttribute('form');
    const rosterLabel = roster.previousElementSibling?.classList.contains('ci-label') ? roster.previousElementSibling : null;
    let anchor = roster;

    if (handle === 'team-flags-pack') {
      if (rosterLabel) rosterLabel.innerHTML = 'Player flags <em>Required</em>';
      roster.remove();
      anchor = rosterLabel || root.querySelector('.ci-value-strip');
    } else if (handle === 'team-national-pack') {
      if (rosterLabel) rosterLabel.innerHTML = '11-player roster — Names <em>Required</em>';
      roster.placeholder = 'Player name — one per line';
    } else {
      if (rosterLabel) rosterLabel.innerHTML = '11-player roster — Names + numbers <em>Required</em>';
      roster.placeholder = 'Player name | number';
    }

    const wrap = document.createElement('div');
    wrap.className = 'ci-team-flag-wrap';

    const shortcut = document.createElement('div');
    shortcut.className = 'ci-team-flag-shortcut';
    const shortcutLabel = document.createElement('label');
    shortcutLabel.className = 'ci-label';
    shortcutLabel.textContent = 'Same flag for the whole team?';
    const shortcutSelect = document.createElement('select');
    shortcutSelect.className = 'ci-field ci-pack-flag-select';
    shortcutSelect.setAttribute('aria-label', 'Set the same flag for all 11 players');
    addOptions(shortcutSelect);
    shortcut.append(shortcutLabel, shortcutSelect);
    wrap.appendChild(shortcut);

    const grid = document.createElement('div');
    grid.className = 'ci-team-flag-grid';
    const playerSelects = [];

    for (let i = 1; i <= 11; i += 1) {
      const item = document.createElement('div');
      item.className = 'ci-team-flag-item';
      const label = document.createElement('label');
      label.className = 'ci-label';
      label.textContent = `Player ${i} flag`;
      const select = makeSelect(`Player ${i} Flag`, formId, true);
      select.id = `ci-player-${i}-flag`;
      label.htmlFor = select.id;
      item.append(label, select);
      grid.appendChild(item);
      playerSelects.push(select);
    }

    shortcutSelect.addEventListener('change', () => {
      playerSelects.forEach(select => {
        select.value = shortcutSelect.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    wrap.appendChild(grid);
    anchor.insertAdjacentElement('afterend', wrap);

    const help = root.querySelector('.ci-help');
    if (help) {
      if (handle === 'team-flags-pack') {
        help.textContent = 'Choose one flag for each player. Use the shortcut above when all 11 players use the same flag. For 20+ players, contact cleaticons@gmail.com.';
      } else if (handle === 'team-national-pack') {
        help.textContent = 'Enter one player name per roster line, then choose the matching flag below. Player 1 flag matches roster line 1. For 20+ players, contact cleaticons@gmail.com.';
      } else {
        help.textContent = 'Enter player name | number on each roster line, then choose the matching flag below. Player 1 flag matches roster line 1. For 20+ players, contact cleaticons@gmail.com.';
      }
    }
  };

  const initRoot = (root) => {
    if (!root || root.dataset.ciPackFlagReady === 'true') return;
    root.dataset.ciPackFlagReady = 'true';
    upgradeSingleFlagInputs(root);
    upgradeTeamFlags(root);
  };

  const init = () => document.querySelectorAll('.ci-customizer').forEach(initRoot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();